import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../HeaderFooter/Header";
import Footer from "../HeaderFooter/Footer";
import "../../styles/projectStyles/ProjectListingLayout.css";

const ProjectListingLayout = ({
  children,
  activeTab,
  setActiveTab,
  tabsTitle = "Projects",
}) => {
  const navigate = useNavigate();

  const handleCreateNewProjectClick = () => {
    // setActiveTab("Create New Project");
    navigate("/projects");
  };

  return (
    <div className="content-layout-container">
      <Header />
      <div className="project_content">
        <div className="tabs-container">
          <h2 className="tabs-title">{tabsTitle}</h2>
          <div className="tabs">
            <button
              className={`tab-item ${
                activeTab === "Create New Project" ? "active" : ""
              }`}
              onClick={handleCreateNewProjectClick}
            >
              <img
                src="/images/back.svg"
                alt="New Project Icon"
                className="tab-icon"
              />{" "}
              Create New Project{" "}
            </button>

            <img
              src="/images/Rectangle.png"
              alt="New Project Icon"
              className="rect-icon"
            />
          </div>
        </div>
        <div className="content-inner">{children}</div>
      </div>
      <Footer />
    </div>
  );
};

export default ProjectListingLayout;
